export default __webpack_public_path__ + "static/media/MetaMask-browser-not-supported.393fb480.svg";